<template>
  <v-dialog v-model="visible" max-width="600px">
    <v-card>
      <v-card-title class="headline" primary-title>
        {{ title }}
      </v-card-title>
      <v-card-text v-show="!!text">{{ text }}</v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="cancel">
          Cancelar
        </v-btn>
        <v-btn color="primary" flat @click="confirm">
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Dialog from "./index";
export default {
  name: "GlobalDialog",
  data() {
    return {
      visible: false,
      title: "",
      text: "",
      resolve: null,
      reject: null
    };
  },
  methods: {
    cancel() {
      if (typeof this.reject === "function") {
        this.reject();
      }
      this.hide();
    },
    hide() {
      this.visible = false;
    },
    confirm() {
      if (typeof this.resolve === "function") {
        this.resolve();
      }
      this.hide();
    },
    show(params) {
      this.visible = true;
      this.title = params.title;
      this.text = params.text;
      this.resolve = params.resolve;
      this.reject = params.reject;
    }
  },
  beforeMount() {
    Dialog.EventBus.$on("show", params => {
      this.show(params);
    });
  }
};
</script>
